import { CoreRankingsTable } from '../../../views';
import { RankingsRowComp } from '../RankingsRow';

/**
 * @desc Rankings Comps Header Class
 * This class using on rankings page ('rankings/comp')
 */
export class RankingsTableComp extends CoreRankingsTable {
	get className() {
		return 'team-rankings league-table shadow';
	}

	get childView() {
		return RankingsRowComp;
	}

	fetchData() {
		return Promise.all( [
			this.collection
				.showCompsOverallRankings(),
			this.rounds.fetch(),
			this.squads.fetch()
		] );
	}
}

export default RankingsTableComp;